<template lang="html">
  <section :id="id">
    <base-modal
      :maxHeight="500"
      :maxWidth="750"
      @on-base-modal-close="onCancelClicked"
    >
      <!-- header  -->
      <template v-slot:header>
        <div class="title">{{ modalTitle }}</div>
      </template>
      <div class="content">
        <add-customer-domain
          id="add-customer-domain"
          :uuid="uuid"
          :uuid-add-new="uuidAddNew"
        />
        <div v-if="saving" class="overlay"></div>
      </div>
      <!-- footer  -->
      <template v-slot:footer>
        <div class="m-group-btns">
          <button
            class="m-button neutral"
            @click.stop="onCancelClicked"
            :disabled="saving"
          >
            {{ getMessageText(messages.CANCEL) }}
          </button>
          <button
            class="m-button brand"
            @click.stop="onOkClicked"
            :disabled="isSubmitDisabled"
          >
            {{ getMessageText(messages.OK) }}
          </button>
        </div>
      </template>
      <div v-if="saving" class="loader"></div>
    </base-modal>
  </section>
</template>

<script lang="js">
  import { MUTATION_NAME, TOAST_OPTIONS } from "@/static/global-variables";
  import distributionChannelUtil from "@/utils/distribution-channel-util";
  import DistributionChannelsService from "@/services/distributionChannelsService";
  import BaseModal from "@/views/drag-drop-pages/components/modal/BaseModal";
  import AddCustomerDomain from "@/components/custom-display-elements/tabs/customer-domains/AddCustomerDomain";

  export default  {
    name: "customer-domain-modal",
    components: {
      BaseModal,
      AddCustomerDomain
    },
    props: {
      id: String,
      uuid: String,
      modalTitle: String,
      uuidAddNew: String
    },
    data() {
      return {
        saving: false
      }
    },
    computed: {
      messages() {
        return this.$store.state.messages;
      },
      customerDomainData() {
        return this.$store.getters[MUTATION_NAME.CUSTOMER_DOMAIN_DATA];
      },
      isSubmitDisabled() {
        return this.saving || !distributionChannelUtil.isValidCustomerDomainInfo(this.customerDomainData)
          || distributionChannelUtil.doesCustomerDomainExistForChannel(this.customerDomainData, this.$store.getters[MUTATION_NAME.CUSTOMER_DOMAINS].customers);
      }
    },
    methods: {
      onCancelClicked() {
        this.$emit("on-add-modal-close");
      },
      onOkClicked() {
        this.saving = true;
        const payload = {...this.customerDomainData};
        delete payload.uuid;
        DistributionChannelsService.addCustomerDomain(payload, this.uuid)
        .then(() => {
          this.$emit("on-add-modal-close");
        })
        .catch((e) => {
          this.$bvToast.toast(this.getMessageText(this.messages.SAVE_ERROR), TOAST_OPTIONS.bottomCenter);
          console.error(e);
        })
        .finally(() => {
          this.saving = false;
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .title {
    text-align: left;
  }
  .content {
    position: relative;
    .overlay {
      height: 100%;
      width: 100%;
      background-color: var(--WHITE, #fff);
      position: absolute;
      top: 0;
      opacity: 0.2;
    }
  }
  .loader {
    width: 2rem;
    height: 2rem;
    position: absolute;
    top: 45%;
    left: 48%;
  }
</style>
